import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useGetSchoolStudentQuery } from '../../store/api/schoolAdminApi'
import { useSchoolFilters } from '../../components/school/SchoolLayout'
import DateRangeBar from '../../components/school/DateRangeBar'
import { KpiCard } from '../../components/school/SchoolUi'

const SchoolStudentDetail: React.FC = () => {
  const { t } = useTranslation('school')
  const { userId } = useParams()
  const { filters } = useSchoolFilters()
  const { data, isLoading } = useGetSchoolStudentQuery({ userId: Number(userId), ...filters })

  if (isLoading) return <div className="text-gray-500">{t('common.loading')}</div>
  if (!data) return <div className="text-gray-500">{t('students.empty')}</div>

  const s = data.student
  return (
    <div className="space-y-6">
      <div>
        <Link to="/pending/students" className="text-sm text-blue-600 hover:underline">{t('students.back')}</Link>
        <h1 className="text-2xl font-bold text-gray-900 mt-2">{s.name}</h1>
        <p className="text-gray-600">{t('students.detailTitle')} · {s.classNames}</p>
      </div>
      <DateRangeBar showClassFilter={false} />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        <KpiCard label={t('students.columns.activities')} value={s.activities} />
        <KpiCard label={t('students.columns.aiSessions')} value={s.aiSessions} />
        <KpiCard label={t('students.columns.interactions')} value={s.interactions} />
        <KpiCard label={t('students.followUps')} value={data.quality?.followUpSessions ?? 0} />
        <KpiCard label={t('students.reflections')} value={data.quality?.reflections ?? 0} />
      </div>
    </div>
  )
}

export default SchoolStudentDetail
